















import {Component, Prop, Vue} from 'vue-property-decorator'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import ConnectWalletNetworkBadge from '@/components/walletConnection/ConnectWalletNetworkBadge.vue'
import NetworkToggle from '@/components/NetworkToggle.vue'

@Component({
  components: {ConnectWalletNetworkBadge, NetworkToggle},
})
export default class ConnectWalletNetworkSelect extends Vue {
  @Prop({type: String, required: true}) walletImplementation!: 'n3' | 'neoX'
  @Prop({type: Array, required: true}) networks!: TWalletNetwork[]
  @Prop({type: String, required: true}) value!: TWalletNetwork
}
